module.exports = __webpack_public_path__ + "static/img/section1.e45c8d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/section1.png
// module id = 16
// module chunks = 0